import api from "../../api/productGeneral";

const getDefaultState = () => {
  return {
    product: {},
    productLoading: false,
    productError: null,

    productNumbers: [],
    productNumbersLoading: false,
    productNumbersError: null,

    mainNumber: [],
    mainNumberLoading: false,
    mainNumberError: null,

    tariffs: [],
    tariffsLoading: false,
    tariffsError: null,

    addons: [],
    addonsLoading: false,
    addonsError: null,

    faultApptEmail: [],
    faultApptEmailLoading: false,
    faultApptEmailError: null,

    products: {},
    searchProductsLoading: false,
    searchProductsError: false,
    searchProductsErrorResponse: null,
  };
};

const state = getDefaultState();

const mutations = {

  FETCH_TARIFFS_BEGIN(state){
    state.tariffs = [];
    state.tariffsLoading = true;
    state.tariffsError = null;
  },
  FETCH_TARIFFS_SUCCESS(state,data){
    state.tariffs = data;
    state.tariffsLoading = false;
    state.tariffsError = null;
  },
  FETCH_TARIFFS_FAILED(state,error){
    state.tariffs = [];
    state.tariffsLoading = false;
    state.tariffsError = error;
  },

  FETCH_ADDONS_BEGIN(state){
    state.addons = [];
    state.addonsLoading = true;
    state.addonsError = null;
  },
  FETCH_ADDONS_SUCCESS(state,data){
    state.addons = data;
    state.addonsLoading = false;
    state.addonsError = null;
  },
  FETCH_ADDONS_FAILED(state,error){
    state.addons = [];
    state.addonsLoading = false;
    state.addonsError = error;
  },

  FETCH_NUMBERS_BEGIN(state){
    state.productNumbersLoading = true;
  },
  FETCH_NUMBERS_SUCCESS(state,data){
    state.productNumbers = data;
    state.productNumbersLoading = false;
    state.productNumbersError = null;
  },
  FETCH_NUMBERS_FAILED(state,error){
    state.productNumbersLoading = false;
    state.productNumbersError = error;
  },

  UPDATE_PRODUCT_BEGIN(state){
    state.productLoading = true;
  },
  UPDATE_PRODUCT_SUCCESS(state,data){
    state.product = data;
    state.productLoading = false;
    state.productError = null;
  },
  UPDATE_PRODUCT_FAILED(state,error){
    state.productLoading = false;
    state.productError = error;
  },

  UPDATE_MAIN_NUMBER_BEGIN(state){
    state.mainNumberLoading = true;
  },
  UPDATE_MAIN_NUMBER_SUCCESS(state,data){
    state.mainNumber = data;
    state.mainNumberLoading = false;
    state.mainNumberError = null;
  },
  UPDATE_MAIN_NUMBER_FAILED(state,error){
    state.mainNumberLoading = false;
    state.mainNumberError = error;
  },

  SEND_FAULT_APPT_EMAIL_BEGIN(state){
    state.faultApptEmailLoading = true;
  },
  SEND_FAULT_APPT_EMAIL_SUCCESS(state,data){
    state.faultApptEmail = data;
    state.faultApptEmailLoading = false;
    state.faultApptEmailError = null;
  },
  SEND_FAULT_APPT_EMAIL_FAILED(state,error){
    state.faultApptEmailLoading = false;
    state.faultApptEmailError = error;
  },

  SEARCH_PRODUCTS_BEGIN(state) {
    state.searchProductsLoading = true;
    state.searchProductsError = false;
    state.searchProductsErrorResponse = null;
  },
  SEARCH_PRODUCTS_SUCCESS(state, payload) {
    state.products = payload;
    state.searchProductsLoading = false;
  },
  SEARCH_PRODUCTS_ERROR(state, err) {
    state.searchProductsLoading = false;
    state.searchProductsError = true;
    state.searchProductsErrorResponse = err;
  },

  RESET_SEARCH_PRODUCTS(state) {
    state.products = {};
  }
};

const actions = {

  async updateProduct({dispatch,commit},payload){
    commit('UPDATE_PRODUCT_BEGIN');
    try{
      const response = await api.updateProduct(payload.product_id,payload.data);
      dispatch("alerts/setAlert", {type:"success",message:payload.success || "Enterprise updated successfully! Reloading."}, { root: true });
      commit('UPDATE_PRODUCT_SUCCESS',response.data);
    }catch(error){
      dispatch("alerts/setAlert", {type:"error",message:error.response.data.message}, { root: true });
      commit('UPDATE_PRODUCT_FAILED',error.response.data.message);
    }
  },

  async updateTelcoProduct({dispatch,commit},payload){
    commit('UPDATE_PRODUCT_BEGIN');
    try{
      const response = await api.updateTelcoProduct(payload.product_id,payload.data);
      dispatch("alerts/setAlert", {type:"success",message:payload.success || "Enterprise updated successfully! Reloading."}, { root: true });
      commit('UPDATE_PRODUCT_SUCCESS',response.data);
    }catch(error){
      dispatch("alerts/setAlert", {type:"error",message:error.response.data.message}, { root: true });
      commit('UPDATE_PRODUCT_FAILED',error.response.data.message);
    }
  },

  async updateMainNumber({dispatch,commit},payload){
    commit('UPDATE_MAIN_NUMBER_BEGIN');
    try{
      const response = await api.updateMainNumber(payload.product_id,payload.number);
      dispatch("alerts/setAlert", {type:"success",message:"Main number updated successfully! Reloading."}, { root: true });
      commit('UPDATE_MAIN_NUMBER_SUCCESS',response.data);
    }catch(error){
      dispatch("alerts/setAlert", {type:"error",message:error.response.data.message}, { root: true });
      commit('UPDATE_MAIN_NUMBER_FAILED',error.response.data.message);
    }
  },

  async fetchTariffs({commit},product){
    const params = {};

    const version = product.tariff_version.replace('TARIFF_V','');
    const kind = product.product_kind==='TELCO' ? product.product_kind : '';
    const supplier = product.supplier || "";

    params.supplier = supplier;
    params.tariff_version = version;
    params.product_kind = kind;

    commit('FETCH_TARIFFS_BEGIN');
    try{
      const data = await api.getTariffs(params);
      commit('FETCH_TARIFFS_SUCCESS',data.data);
    }catch(error){
      commit('FETCH_TARIFFS_FAILED',error);
    }
  },

  async fetchAddons({commit},product){
    const params = {};

    const version = product.tariff_version.replace('TARIFF_V','');
    const kind = product.product_kind;
    const supplier = product.supplier || "";
    
    params.supplier = supplier;
    params.tariff_version = version;
    params.product_kind__in = kind;


    commit('FETCH_ADDONS_BEGIN');
    try{
      const data = await api.getAddons(params);
      commit('FETCH_ADDONS_SUCCESS',data.data);
    }catch(error){
      commit('FETCH_ADDONS_FAILED',error);
    }
  },

  async fetchNumbers({commit},product){
    commit('FETCH_NUMBERS_BEGIN');
    try{
      const data = await api.getNumbers(product.id);
      commit('FETCH_NUMBERS_SUCCESS',data.data);
    }catch(error){
      commit('FETCH_NUMBERS_FAILED',error);
    }
  },

  async sendFaultApptEmail({commit},product){
    commit('SEND_FAULT_APPT_EMAIL_BEGIN');
    try{
      const data = await api.sendFaultApptEmail(product.id);
      commit('SEND_FAULT_APPT_EMAIL_SUCCESS',data.data);
    }catch(error){
      commit('SEND_FAULT_APPT_EMAIL_FAILED',error.response.data.message);
    }
  },

  async searchProducts({ commit, dispatch }, payload) {
    commit('SEARCH_PRODUCTS_BEGIN');
    try {
      const data = await api.searchProducts(payload);
      commit('SEARCH_PRODUCTS_SUCCESS', data.data);
    } catch(err) {
      dispatch('alerts/setAlert', {type: 'error', message: err}, { root: true });
      commit('SEARCH_PRODUCTS_ERROR', err);
    }
  },
};

const calculateLengths = (length)=>{
  const lengths = [1,12,18,24,36,48].splice([1,12,18,24,36,48].indexOf(length));
  return lengths.map(len=>({
    text: len===1 ? `Month to Month` : `${len} Months`,
    value: len,
  }));
}

const getters = {

  getTariffs: (state) => state.tariffs.filter(e=>e.available),
  getIsTariffsLoading: (state) => state.tariffsLoading,
  getTariffsError: (state) => state.tariffsError,

  getProduct: (state) => state.product,
  getIsProductLoading: (state) => state.productLoading,
  getProductError: (state) => state.productError,

  getMainNumber: (state) => state.mainNumber,
  getIsMainNumberLoading: (state) => state.mainNumberLoading,
  getMainNumberError: (state) => state.mainNumberError,

  getContractLengths: (state) => (length) => calculateLengths(length),
  getPromos: (state) => (promos,length) => {
    const promosArray = [{ name: 'No Promo', value: null }];
    if(promos && length){
      return promosArray.concat(promos.filter(e=>e.available && e.promo.min_contract_length_months <= length).map(p=>({...p.promo})));
    }
    return promosArray;
  },
  
  getSelectedTariff: (state) => (id) => state.tariffs.filter(e=>e.id===id)[0] ? state.tariffs.filter(e=>e.id===id)[0] : {},

  getSelectedPromo: (state) => (tariff_id,promo_id) => {
    const tariff = state.tariffs.filter(e=>e.id===tariff_id)[0] ? state.tariffs.filter(e=>e.id===tariff_id)[0] : null;
    return tariff && tariff.promos.filter(e=>e.promo.id===promo_id)[0] ? tariff.promos.filter(e=>e.promo.id===promo_id)[0].promo : {}
  },

  getAddons: (state) => state.addons,
  getAvailableAddons: (state) => state.addons.filter(e=>e.available),
  getIsAddonsLoading: (state) => state.addonsLoading,
  getAddonsError: (state) => state.addonsError,
  
  getSelectedAddon: (state) => (product) => {
    const ids = product.addons.map(e=>e.addon_id);
    const quantity = product.addons.map(e=>({
      id: e.addon_id,
      quantity: e.quantity
    }));
    
    return state.addons.filter(e=>ids.includes(e.id)).map(e=>({
      id: e.id,
      name: e.name,
      price: e.standard_price,
      quantity: quantity.find(f=>f.id===e.id).quantity
    }));
  },

  getProductNumbers: (state) => state.productNumbers.filter(e=>e.extension==='Not Assigned' || e.extension==='Pilot Number' || e.extension==='Main Number').map(e=>({text:`${e.number}`, value:e.id})),
  getIsProductNumbersLoading: (state) => state.productNumbersLoading,
  getProductNumbersError: (state) => state.productNumbersError,

  getFaultApptEmail: (state) => state.faultApptEmail,
  getIsFaultApptEmailLoading: (state) => state.faultApptEmailLoading,
  getFaultApptEmailError: (state) => state.faultApptEmailError,

  getProducts: state => state.products.results,
  getIsProducts: state => state.products.count > 0,
  getSearchProductsLoading: state => state.searchProductsLoading,
  getSearchProductsError: state => state.searchProductsError,
  getSearchProductsErrorResponse: state => state.searchProductsErrorResponse,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
